import gql from 'graphql-tag'

const getRedeemPaused = schema => gql`query getRedeemPaused {
    ${schema}_loyaltyprogram {
        id
        bll_redeem_paused__c
    }
  }`

export default getRedeemPaused

